export const formatLocalTimezone = (datetime: string) => {
  if (datetime === null) {
    return ''
  }
  try {
    const date = new Date(datetime)
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions()
    const locale = navigator.languages[0]
    return new Intl.DateTimeFormat(locale, {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short',
      timeZone
    }).format(date)
  } catch (_err) {
    return ''
  }
}
